import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// PWA bootstrap — registering this is what flips Chrome / Edge into
// treating the site as installable. The worker itself is intentionally
// minimal (see public/service-worker.js).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // Service worker registration is best-effort. The site still
      // works without it — the install banner just won't show.
    });
  });
}
